import { FetchRequestError } from "./FetchRequestError";

export class FetchElevatedAccessError extends FetchRequestError {
  /**
   * Backend-intended user flow: the request reached an endpoint that requires
   * elevated access (e.g. recent re-auth) and surfaces an in-product prompt
   * for the user to elevate. Suppress from RUM/Sentry to avoid inflating
   * monitoring with non-actionable events.
   */
  override isUnexpectedSystemError(): boolean {
    return false;
  }
}
